import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";
import AppPosthogProvider from "@/providers/PosthogProvider";
import SeoMeta from "@/components/SeoMeta";

function App() {
    return (
        <AppPosthogProvider>
            <div className="App">
                <SeoMeta />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" richColors />
            </div>
        </AppPosthogProvider>
    );
}

export default App;
